<template>
<div class="radio-list">
    <div v-for="item in choices" :key="item.name"
        :class="['radio-item', { 'active': currentValue == item.name }]"
        @click="onClick(item)">
        <div class="radio-item-circle">
            <span class="inner"></span>
        </div>

        {{ item.label }}
    </div>
</div>
</template>

<script>
export default {
    name: "radio-list",

    props: ["currentValue", "choices"],

    methods: {
        onClick: function (item) {
            if (item.name === this.currentValue) {
                this.$emit("change", null)
            } else {
                this.$emit("change", item.name)
            }
        }
    }
}
</script>

<style>
.radio-item {
    align-items: center;
    cursor: pointer;
    display: flex;
    transition: all 0.15s ease;
    user-select: none;
}

.radio-item + .radio-item {
    margin-top: 5px;
}

.radio-item-circle {
    border: 1px solid #bcbcbc;
    border-radius: 100%;
    height: 16px;
    margin-right: 10px;
    padding: 2px;
    width: 16px;
}

.radio-item-circle .inner {
    background: transparent;
    border-radius: 100%;
    display: block;
    height: 100%;
    transition: all 0.15s ease;
}

.radio-item-input {
    display: none;
}

.radio-item.active {
    border-color: #4874eb;
}

.radio-item.active .radio-item-circle .inner {
    background: #4688f0;
}
</style>



// WEBPACK FOOTER //
// src/components/RadioList.vue